import ZEntity from './ZEntity.js';
// import requester from '@/assets/dataSources/zforms/requester.js';


export default window.ZForms.registerClass('container', class ZEntityContainer extends ZEntity {
  constructor() {
    super(...arguments);
    this.contentMeta = null;
    this.content = [];
    this.pgData = null;
    this.view = null;
    this.description = null;
  }

  async _updateParamsFromRaw(rawData) {
    await super._updateParamsFromRaw(rawData);
    this.view = rawData.view === undefined ? this.view : rawData.view;
    this.description = rawData.description === undefined ? this.description : rawData.description;
  }

  async _updateContentMetaFromRaw(rawData) {
    this.contentMeta = this.contentMeta == null ? this.getEmptyMeta() : this.contentMeta;
    await this.contentMeta.updateFromRaw(rawData.content_meta == null ? {} : rawData.content_meta);
  }

  async _updateMetaFromRaw(rawData) {
    await super._updateMetaFromRaw(rawData);
    await this._updateContentMetaFromRaw(rawData);
  }

  async _updateValuesAndErrorsFromRaw(rawData) {
    await super._updateValuesAndErrorsFromRaw(rawData);
    await this._updateContentFromRaw(rawData);
  }

  async _updateContentFromRaw(rawData) {
    if (rawData.pg_data != null) {
      this.pgData = this.pgData == null ? {} : this.pgData;
      Object.keys(rawData.pg_data).forEach((attr) => this.pgData[attr] = rawData.pg_data[attr]);
    }

    if (rawData.content != null) {
      this.content = await Promise.all(rawData.content.map(async (rawEntity, idx) => {
        const curRes = await this.parseRawEntity(rawEntity);
        curRes.inContainerNumber = idx;
        return curRes;
      }));
    }
  }

  async parseRawEntity(rawEntity) {
    return await window.ZForms.parseRaw(rawEntity, this.contentMeta, this.rootEntity);
  }

  // getFirstCached() {
  //   return this.content[0];
  // }

  // getAllCached() {
  //   return this.content;
  // }

  async callContentAll() {
    if (this.pgData == null || this.pgData.finished) return;

    // const appendData = await requester({
    //   entityName: this.meta.entityName,
    //   entityUid: this.getUid(),
    //   // subscriptionUid,
    //   dsUid: this.meta.dsUid,
    //   forceUpdate: true,
    //   // pageUid: pageUid,
    //   actionData: this.pgData,
    //   isPgReq: true,
    //   defaultParser: 'container',
    // });

    // if (appendData.status != 200) throw new Error(appendData.errorText + '\nСтатус: ' + appendData.status);

    // await this.updateFromRaw(appendData.result);

    // this.pgData = appendData.result.pgData;
    // this.content = appendData.result.content;
  }

  getFirst() {
    return this.content[0];
  }

  getAll() {
    return this.content;
  }

  getDefaultEntityType() {
    return this.contentMeta.zfType;
  }

  async getDefaultEmptyEntity() {
    const rawEntity = {};
    rawEntity[this.contentMeta.metaAttrName] = {'zf_type': this.getDefaultEntityType()};
    return await window.ZForms.parseRaw(rawEntity, this.contentMeta, this.rootEntity);
  }
});
